import classNames from "classnames";

import { Header } from "../../components/header/header";

export const AboutPage = () => {
    return (
        <div className="f-pg">
            <Header />
            <div style={{width: '100vw' }}>
                <img src="/images/pic1.jpeg" alt="" width={window.innerWidth*0.9 } />
            </div>
        </div>
    );
}